// @ts-nocheck
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, ComponentType, TemplatePortal } from '@angular/cdk/portal';
import { ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';

export class OverlayHelper {
	private overlayConfiguration!: OverlayConfig;
	private overlayRef!: OverlayRef;
	private refComponent: any;
	private clickOutsideOverlay: boolean = false;
	private subscription: Subscription | null = null;
	// private ngZone: NgZone = new NgZone({});
	// private platform: Platform = new Platform();
	// private scrollDispatcher: ScrollDispatcher = new ScrollDispatcher(this.ngZone, this.platform);

	constructor(private overlay: Overlay) {}

	public setConfiguration = (config: overlayUserConfiguration) => {
		let positionStrategy;
		const backdropConf = { hasBackdrop: false, backdropClass: 'bg-transparent' };

		if (config.backdropClick) backdropConf.hasBackdrop = true;

		if (config.positionStrategy === 'flexible') {
			const flexiblePositionStrategy = this.overlay
				.position()
				.flexibleConnectedTo(config.connectedTo!);

			let withPositions: any = [
				{
					originX: 'end',
					originY: 'bottom',
					overlayX: 'end',
					overlayY: 'top',
				},
			];

			if (config.flexiblePositionStrategy && config.flexiblePositionStrategy.length > 0) {
				withPositions = config.flexiblePositionStrategy;
			}

			flexiblePositionStrategy.withPositions(withPositions);

			if (config.offsetX) flexiblePositionStrategy.withDefaultOffsetX(config.offsetX);
			if (config.offsetY) flexiblePositionStrategy.withDefaultOffsetY(config.offsetY);

			positionStrategy = flexiblePositionStrategy;
		} else {
			const fixedPositionStrategy = this.overlay.position().global();
			// .centerHorizontally().centerVertically();

			if (config.offsetX) fixedPositionStrategy.centerHorizontally(String(config.offsetX));
			else fixedPositionStrategy.centerHorizontally();
			if (config.offsetY) fixedPositionStrategy.centerVertically(String(config.offsetY));
			else fixedPositionStrategy.centerVertically();

			positionStrategy = fixedPositionStrategy;
		}

		let scrollStrategy;

		if (config.scrollStrategy === 'block') {
			scrollStrategy = this.overlay.scrollStrategies.block();
		} else if (config.scrollStrategy === 'close') {
			// this.timepickerFactory = new TimePickerFactory(this.scrollDispatcher, this.ngZone, document.documentElement);
			// scrollStrategy = this.timepickerFactory.close();
			scrollStrategy = this.overlay.scrollStrategies.close();
		} else if (config.scrollStrategy === 'reposition') {
			scrollStrategy = this.overlay.scrollStrategies.reposition();
		} else {
			scrollStrategy = this.overlay.scrollStrategies.noop();
		}

		const conf = { positionStrategy, scrollStrategy, ...backdropConf };

		this.overlayConfiguration = new OverlayConfig(conf);
	};

	public outsideClick(): boolean {
		return this.clickOutsideOverlay;
	}

	public show(component: ComponentType<unknown> | TemplatePortal) {
		this.close();

		if (!this.overlayRef) this.overlayRef = this.overlay.create(this.overlayConfiguration);

		this.subscription = this.overlayRef
			.backdropClick()
			.subscribe(() => (this.clickOutsideOverlay = true));

		let portalComponent: any = component;

		if (!(component instanceof TemplatePortal)) {
			const isComponent: ComponentType<unknown> = component;
			portalComponent = new ComponentPortal(isComponent);
		}

		this.refComponent = this.overlayRef.attach(portalComponent);
	}

	public close() {
		if (this.subscription) this.subscription.unsubscribe();
		this.clickOutsideOverlay = false;
		if (!this.overlayRef) return;
		this.overlayRef.detach();
	}

	public actualizeData(key, value) {
		this.refComponent.instance[key] = value;
	}
}

export interface overlayUserConfiguration {
	positionStrategy: 'flexible' | 'fixed';
	offsetX?: number;
	offsetY?: number;
	connectedTo?: ElementRef;
	flexiblePositionStrategy?: Array<{
		originX: 'start' | 'bottom' | 'end' | 'top';
		originY: 'start' | 'bottom' | 'end' | 'top';
		overlayX: 'start' | 'bottom' | 'end' | 'top';
		overlayY: 'start' | 'bottom' | 'end' | 'top';
	}>;
	scrollStrategy: 'block' | 'close' | 'noop' | 'reposition';
	backdropClick?: boolean;
}
